// extracted by mini-css-extract-plugin
export default {"author-timestamp-view__author":"styles_author-timestamp-view__author__hf8qC","author-timestamp-view__timestamp":"styles_author-timestamp-view__timestamp__r217w"};